const drivingQuestionUrl = '/driving-question';

export default drivingQuestionUrl;
